<template>
  <div>
    <v-card style="border-radius: 10px" flat class="pb-3">
      <v-card-title primary-title class='primary white--text py-3 px-0'>
        <div class="pl-5">Cursos concluídos</div>
      </v-card-title>
      <card-loading-transparent v-if="loading" class="pt-3"></card-loading-transparent>
      <v-card-text v-if="!loading" class="mb-n3 pa-0 pb-1">
        <div v-if="!loading && items.length <= 0" class="grey--text title mt-6 mb-n1" style="text-align: center">
          Você não possui nenhum curso concluído
        </div>
        <v-data-iterator 
          height="600px" 
          hide-default-footer  
          class="mb-2 mx-3"
          :items="items" 
          :items-per-page.sync="itemsPerPage" 
          :page.sync="page"
          :sort-by="sortBy.toLowerCase()" 
          :sort-desc="sortDesc" 
          v-if="!loading && items.length > 0" 
        >
        <template v-slot:no-data>
          <div v-if="$route.name == 'MyCourseList'" class="grey--text title mt-6 mb-n1" style="text-align: center">
            Você não possui certificados disponíveis.
          </div>
        </template>
          <template v-slot:default="props">
            <div  v-for="item in props.items" :key="item.idx">
              <v-card class="mt-3" outlined :style="item.form_answered ? 'border-left: 5px solid #1976D2;' : 'border-left: 5px solid #FF0000;' ">
                <v-card-title class="d-flex flex-column align-start pb-1">
                  <div 
                    :class="['font-weight-medium blue-grey--text text--darken-4', card_title]" 
                    style="word-break: break-word"
                  >{{item.name}}</div>
                </v-card-title>
                <v-card-text class="pb-1">
                  <div 
                    :class="['font-weight-medium blue-grey--text text--darken-4', card_text]" 
                    style="word-break: break-word"
                  >Concluído em: <span class="text-body-2">{{$dayjs(item.end_date).format('DD/MM/YYYY')}}</span> </div>
                  <div 
                    v-if="!item.form_answered"
                    :class="['font-weight-medium blue-grey--text text--darken-4', card_text]" 
                    style="word-break: break-word"
                  ><span class="red--text ml-n2">*</span>Formulário de avaliação: <span class="text-body-2">Não respondido</span></div>
                </v-card-text>
                <v-card-actions class=" pt-4">
                  <v-spacer></v-spacer>
                  <v-btn v-if="item.is_approved && !item.is_international_course" @click="certificateDialog(item)" small :color="item.form_answered == true ? 'primary' : 'error'">
                    <v-icon left>
                      mdi-seal-variant
                    </v-icon>
                    Certificado
                  </v-btn>
                  <v-btn v-if="!item.is_approved && !item.form_answered" @click="certificateDialog(item)" small color="primary">
                    Avaliar curso
                  </v-btn>
                </v-card-actions>
                <div class="d-flex justify-end pb-2 pr-2" v-if="!item.is_approved">
                  <v-chip  class="pl-4" label dark color="red" style="max-height: 28px">
                    <span class="font-weight-normal text-Caption">Reprovado</span>
                  </v-chip>
                </div>
              </v-card>
            </div>
          </template>
          <template v-slot:footer>
            <v-row class="mt-5 px-6" align="center" justify="center" v-if="1 < numberOfPages">
              <span class="grey--text">Itens por página</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on" >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(number, index) in itemsPerPageArray" :key="index" @click="updateItemsPerPage(number)">
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <span class="mr-4 grey--text">
                Pagina {{ page }} de {{ numberOfPages }}
              </span>
              <div>
                <v-btn fab dark color="blue darken-3" x-small class="mr-1 elevation-0" @click="formerPage">
                  <v-icon size='22'>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="blue darken-3" x-small class="ml-1 elevation-0" @click="nextPage">
                  <v-icon size='22'>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card-text>
      <v-card-actions class="justify-center">
      </v-card-actions>
    </v-card>
    <dialog-loading v-if="loading_certificate"></dialog-loading>
    <dialog-show-file 
      v-if="!loading_certificate"
      title="Certificado" 
      @closeDialog="handleCloseDialog" 
      :dialog_file="dialog && !loading_certificate" 
      file_kind="application/pdf" 
      :file_url="file_url"
    ></dialog-show-file>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Api from '@/api/index';
import validations from '@/mixins/validations';

export default {
  name: 'ConcludedCourses',
  mixins: [
    validations
  ],
  props: {
    user_id: {
      type: Number,
      defalt: null
    }
  },
  data() {
    return { 
      itemsPerPageArray: 2,
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: 'start_date',
      items: [],
      loading: false,
      dialog: false,
      file_url: null,
      loading_certificate: false,
    }
  },
  mounted () {
    this.getCourses()
  },
  methods: {
    handleCloseDialog(){
      this.dialog = false
    },
    certificateDialog(item){
      if(item.form_answered == true){
        let swall_settings = { btn_text: 'Abrir', msg: 'Deseja abrir seu certificado ?', icon: 'question' }
        this.swallAction(swall_settings).then(( r )=>{
          if(r.isConfirmed) {
            this.loading_certificate = true
            Api.Enrolled.index({course_id: item.id, certificate_url_request: true}).then(r=>r.data).then(d=> {
              this.file_url = d[0].certificate_file_url
              this.dialog = true
            }).catch((err)=>{
              this.addNotification({type: 'error', msg: `Ops, ocorreu um erro...`})
              this.dialog = false
            }).finally(()=> {
              this.loading_certificate = false
            })
          }
        })
      }else{
        let swall_settings = { btn_text: 'Preencher', msg: 'Formulário de avaliação ainda não foi preenchido', icon: 'warning' }
        this.swallAction(swall_settings).then((params)=>{

          params.isConfirmed == true ? this.$router.push({name: 'CourseRating', params:{course_id: item.id}}) : ''

        })
      }
    },
    swallAction(swall_settings){
      return this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: swall_settings.btn_text,
        title: swall_settings.msg,
        icon: swall_settings.icon,
      })
    },
    getCourses(){
      this.loading = true
      Api.MyCourse.index({courses: 'concluded'}).then(r => r.data).then(r => {
        this.setItems(r)
      }).catch(error => {
        console.log(error)
      })
    },
    setItems(items){
      setTimeout(()=>{
        this.items = items
        this.loading = false
      },1200)
    },
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },
    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },
    card_title(){
      return this.$vuetify.breakpoint.smAndUp ? 'text-h6' : 'text-subtitle-1'
    },
    card_text(){
      return this.$vuetify.breakpoint.smAndUp ? 'text-body-1' : 'text-body-2'
    },
    ...mapState({
      user: state=> state.User.user,
    })
  },
}
</script>

<style>
</style>